export default "__VITE_ASSET__C0FM$4Fb__"